import { get } from 'lodash'

export default function () {
  if (get(this.$route, 'params.tower_id', null) !== null) {
    this.selectUnitsTower(get(this.$route, 'params.tower_id', null))
  }
  this.getTowersDweller()
}



// WEBPACK FOOTER //
// ./src/app/dweller/pets/form/resources/mounted.js